import styled from "@emotion/styled";
import { breakpoints } from "../../../constants";
import { getCybersecurityIconForCategory } from "../../../util/cyberSecurityUtil";

const StyledTypeFilterItem = styled.div<{ isActive: boolean }>`
  width: 208px;
  min-height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  margin-bottom: 1px;
  border-radius: 6px;
  gap: 4px;
  cursor: pointer;
  background: ${(props) =>
    props.isActive ? "var(--fifth-black-color)" : "var(--primary-white-color)"};

  @media (max-width: ${breakpoints.small}px) {
    width: 100%;
  }

  img {
    border: ${(props) =>
      props.isActive && "1px solid var(--secondary-red-color)"};
  }

  &:hover {
    background-color: ${(props) =>
      props.isActive ? "var(--fifth-black-color)" : "var(--sixth-black-color)"};
    img {
      background: var(--primary-white-color);
    }
  }
`;

const StyledTypeItemName = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 21px;
  color: var(--secondary-black-color);
`;

interface Props {
  option: string;
  label?: string;
  isActive: boolean;
  onClick: () => void;
}

const CyberSecurityCategoryFilterItem = ({
  option,
  label,
  isActive,
  onClick,
}: Props) => {
  return (
    <StyledTypeFilterItem key={option} isActive={isActive} onClick={onClick}>
      <img
        src={getCybersecurityIconForCategory(option)}
        alt={option}
        width="32px"
        height="32px"
      />
      <StyledTypeItemName>{label ?? option}</StyledTypeItemName>
    </StyledTypeFilterItem>
  );
};

export default CyberSecurityCategoryFilterItem;
